<template>
  <div class="flex gap-4">
    <a :href="social.link" v-for="social in links" target="_blank" :title="social.name" class="hover:text-(--accent-color) transition-[color]">
      <IconSprite :id="social.name" class="text-[20px] mt-5"/>
    </a>
  </div>
</template>

<script lang="ts">
import type {PropType} from "vue";
import {IconSprite} from "@/components/helpers";

export default {
  name: 'SocialMedia',
  components: {IconSprite},
  props: {
    socials: {
      type: Object as PropType<Socials>,
      required: true
    }
  },
  computed: {
    links(this: { socials: Socials }): { link: string; name: string }[] {
      return (Object.keys(this.socials) as (keyof Socials)[])
          .filter(name => this.socials[name])
          .map(name => ({link: this.socials[name]!, name}))
    }
  }
}
</script>